export default __webpack_public_path__ + "static/media/web-expl.5afe6ff5.png";